import { inject, Injectable } from '@angular/core';
import { IFormModel } from '../../../../../../common/apis/form/model/form.model';
import { FormType, ITeamsMetadata } from '@oogaday/shared';
import { ICompetitionGroupModel } from '../../../../../../common/apis/competition-group/model/competitoin-group.model';
import { CompetitionGroupApiService } from '../../../../../../common/apis/competition-group/competition-group-api.service';
import { NamesMetadataMapping } from '../../form-results/common/model/model';

@Injectable({
  providedIn: 'root',
})
export class CompetitionGroupCommonService {
  private readonly compGroupApi = inject(CompetitionGroupApiService);


  private compGroups: ICompetitionGroupModel[] | undefined;

  async fetchUserCompGroups(): Promise<void> {
    this.compGroups = await this.compGroupApi.getUserCompGroups();
  }

  getCompGroupInfo(compGroupId: string): ICompetitionGroupModel {
    return this.compGroups!.find(({ id }) => id === compGroupId)!;
  }

  flattenMetadata(form: IFormModel): NamesMetadataMapping {
    switch (form.formType) {
      case FormType.MATCH:
      case FormType.GROUP_STAGE:
      case FormType.TOURNAMENT_GENERAL:
      case FormType.PLAYOFF_STAGE:
      case FormType.CHAMPIONS_LEAGUE:
        return (form.metadata as ITeamsMetadata).teams.reduce((obj: NamesMetadataMapping, team) => {
          obj.teams.set(team.id, team.name);
          team.players.forEach(({ id, name }) => obj.players.set(id, name));

          return obj;
        }, { teams: new Map(), players: new Map() });
      default:
        throw new Error('Not supported type');
    }
  }
}
